import React from 'react';
import InjectedPropsContext from './InjectedPropsContext';

/**
 * This class allows for the applicaton of props to all core components that are children or sub children of the component.
 * This is done via the 'propInjector' callback that is passed in. The prop injector is expected to be a function that
 * takes the props a component would receive and expects to return either null if no props should be changed, or a new
 * object that will be patched against the original props.
 * See InjectedPropsConsumer for further implementation details.
 **
 * Important Note: for a component to recieve injected props it MUST be a consumer, see withInjectedProps.js for a helper function for this.
 */
const InjectedPropsProvider = ({ getProviderProps, children }) => (
  <InjectedPropsContext.Provider value={getProviderProps}>{children}</InjectedPropsContext.Provider>
);
export { InjectedPropsProvider };
export default InjectedPropsProvider;
